/* eslint-disable sort-imports */

/* eslint-disable import/newline-after-import */
import '../../static/node_modules/bootstrap.css';
import '@liveauctioneers/caterwaul-components/theme/theme.css';
require('@/theme/fonts.scss');
require('@/theme/theme.css');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');
require('../../static/feedback.css');

import { ConnectedRouter } from 'connected-react-router';
import ErrorBoundary from '@liveauctioneers/caterwaul-components/lib/ErrorBoundary/ErrorBoundary';
import { captureError, installSentry } from '@/utils/errorTracking';
import { HelmetProvider } from 'react-helmet-async';
import { isOnline } from '@/utils/isOnline';
import NoCookies from './NoCookies';

import { persistStore } from 'redux-persist';
import Provider from '@/components/IntlRedux/Provider';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';
import { loadableReady } from '@loadable/component';
import { renderRoutes } from 'react-router-config';
import { LastLocationProvider } from 'react-router-last-location';
import RouteDataLoader from './RouteDataLoader';
import App from '@/pages/App/App';
import { ThemeProvider } from 'styled-components';
import appTheme from '@liveauctioneers/caterwaul-components/lib/theme/theme';

function localStorageCheck() {
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

ReactModal.setAppElement('#content');

/**
 * Renders the client-side React SPA
 */
type RenderAppParams = { history: any; routes: any; store: any };
const renderApp = ({ history, routes, store }: RenderAppParams) => {
    const dest = document.getElementById('content');
    const localStoragePersistConfig = {
        debounce: 33,
        keyPrefix: 'la:',
        whitelist: ['forgotPassword', 'persist', 'recentItem'],
    };

    /* eslint-disable no-unused-vars */
    // @ts-ignore
    Promise.all([window.__data ? true : isOnline()]).then(() => {
        if (!localStorageCheck() && dest) {
            return ReactDOM.render(<NoCookies />, dest);
        }

        const {
            config: { buildNumber, deployment, sentryDsn },
        } = store.getState();

        installSentry({ dsn: sentryDsn, environment: deployment, release: buildNumber });

        // save to local storage
        persistStore(store, localStoragePersistConfig);

        // Only hydrate in production
        const reactRenderer = (module as any).hot ? ReactDOM.render : ReactDOM.hydrate;

        const helmetContext = {};

        /**
         * Wait for all loadable components to be loaded
         * @see https://loadable-components.com/docs/api-loadable-component/#loadableready
         */
        loadableReady(() => {
            if (dest) {
                reactRenderer(
                    <ThemeProvider theme={appTheme}>
                        <ErrorBoundary onError={captureError}>
                            <HelmetProvider context={helmetContext}>
                                <Provider key="provider" store={store}>
                                    <ConnectedRouter history={history}>
                                        <LastLocationProvider>
                                            <App>
                                                <RouteDataLoader routes={routes} store={store}>
                                                    {renderRoutes(routes)}
                                                </RouteDataLoader>
                                            </App>
                                        </LastLocationProvider>
                                    </ConnectedRouter>
                                </Provider>
                            </HelmetProvider>
                        </ErrorBoundary>
                    </ThemeProvider>,
                    dest
                );
            }
        });

        if (process.env.NODE_ENV !== 'production') {
            window.React = React; // enable debugger
        }
    });
};

export default renderApp;
